import {createRoot} from 'react-dom/client';
import '@prtimes-basis/styles/reset.css';
import '@prtimes-basis/styles/global.css';
import '../../../public/new-ui-global.css';
import '../../../public/editor-global.css';
import {PreviewPressReleasePage} from '@/features/preview-press-release';

const container = document.querySelector('#root');
if (container !== null)
  createRoot(container).render(<PreviewPressReleasePage />);
